import React from 'react';
import $ from 'jquery';
import _find from 'lodash/find';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import Scroll, {Element, scroller}  from 'react-scroll';

import {TimelineLite} from 'gsap';

import {browserHistory} from 'react-router';

import Display from '../parts/display';
import ProfileTile from './profileTile';
import HoverPanel from '../parts/hoverPanel';
class PortfolioBlock extends React.Component {
    constructor() {
        super();
        this.state = {
            animated: false,
            items: [],
            list: [],
            pageOpen: false,
            randomNumber: 20,
            firstLoad: false,
            displayScroll: false,
            couldntLoad: false,
            loadCount: 1
        };
        this.updateItems = this.updateItems.bind(this);
        this.animateOpen = this.animateOpen.bind(this);
        this.animateClose = this.animateClose.bind(this);
        this.detectScroll = this.detectScroll.bind(this);
    }
    updateItems(items){
        this.setState({items: items});
        this.forceUpdate();
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.items !== this.props.items){
            this.setList();
            this.randomNumber();
        }
        if(this.props.site.pageChange !== nextProps.site.pageChange){
            if((nextProps.site.pageChange.next.match(/\//g) || []).length <= 2 && this.state.pageOpen){
                this.props.actions.selectPortfolio(null);
                this.tl.reverse();
            }
            // console.log(nextProps.site.pageChange);
        }
        if(this.props.pageSlug && nextProps.pageSlug.length > 1 && !this.state.firstLoad && this.props.site.selectedPortfolios.length > 1){
            this.setState({
                firstLoad: true
            });
            if(_find(this.props.site.selectedPortfolios, {slug: this.props.pageSlug})){
                this.startOpenAnim();
            }else{
                this.setState({couldntLoad: true});
                this.props.loadMore();
                $('body').css({
                    overflowY: 'hidden',
                    height: '100vh'
                });
                scroller.scrollTo('scrollToLoading', {
                    duration: 1000,
                    delay: 0,
                    smooth: true
                });
            }
        }
        if(this.state.couldntLoad && this.props.site.selectedPortfolios.length !== nextProps.site.selectedPortfolios.length){

            if(_.find(this.props.site.selectedPortfolios, {slug: this.props.pageSlug})){
                this.startOpenAnim();
            }else if(this.state.loadCount < 5){
                this.props.loadMore();
                this.setState({
                    loadCount: this.state.loadCount + 1
                });
                scroller.scrollTo('scrollToLoading', {
                    duration: 1000,
                    delay: 0,
                    smooth: true
                });
            }else{
                this.props.private? browserHistory.push('/private-portfolio'): browserHistory.push('/portfolio');
            }
        }
    }
    componentWillUnmount(){
        if(this.state.pageOpen){
            $('body').css({
                overflowY: 'auto',
                height: 'auto'
            });
        }
    }
    setList(){
        var arr = [];
        while (arr.length < (this.props.items.length + 1)) {
            var randomnumber = Math.floor(Math.random() * (this.props.items.length + 1));
            var found = false;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] == randomnumber) {
                    found = true;
                    break
                }
            }
            if (!found)arr[arr.length] = randomnumber;
        }
        let n = Math.round(Math.random() * 2);

        // if(n == 1){
            this.setState({
                list: [0,101,1,16,104,2,106,3,108,109,4,111,112,5,114,6,116,117,7,119,120,8,9,123,10,125,126,13,11,14,11,132,133,12,15]
            });
        // }else{
        //     this.setState({
        //         list: [0,101,102,103,104,1,106,2,108,109,3,111,112,4,114,5,116,117,6,119,120,7,8,123,9,125,126,128,10,130,131,132,133,11]
        //     });
        // }


        // this.setState({
        //     list: _.shuffle([0,1, 2, 3, 4, 99, 99, 99, 99])
        // });
    }
    startOpenAnim(){
        let _this = this;
        this.tl = new TimelineLite();
        let placeholder = this.refs.childPage;
        placeholder.style.position = 'absolute';
        $('body').css({
            overflowY: 'hidden',
            height: '100vh'
        });
        $(placeholder).css({
            zIndex: 999
        });
        this.tl.eventCallback("onReverseComplete", function(){
            $('body').css({
                overflowY: 'auto',
                height: 'auto'
            });

            $(placeholder).css({
                zIndex: -1
            });
        });

        this.tl
            .to(placeholder, .3, { background: 'rgb(246,246,246)'})
            .to(placeholder, .3, { width: '100%', left: 0})
            .to(placeholder, .3, {top: $(window).scrollTop() + 65, height: window.innerHeight - 65})
            .to(placeholder, .3, {background: 'rgb(255,255,255)', onComplete: function () {
                _this.props.actions.selectPortfolio(_this.props.pageSlug);
                // browserHistory.push(_this.props.pathname + '/' + this.props.pageSlug);
            }});
    }
    animateOpen(a){
        let _this = this;
        let thing = $(a.currentTarget).attr('data-slug');
        this.tl = new TimelineLite();
        let menuPosition =  a.currentTarget.getBoundingClientRect();
        let menuOffset = $(a.currentTarget).offset();
        let placeholder = this.refs.childPage;
        placeholder.style.width = menuPosition.width + 'px';
        placeholder.style.height = menuPosition.width + 'px';
        placeholder.style.top = menuOffset.top + 'px';
        placeholder.style.left = menuOffset.left  + 'px';
        placeholder.style.zIndex = 999;
        placeholder.style.position = 'absolute';
        this.placeholder = placeholder;

        //$('#app').append(placeholder);

        this.tl.eventCallback("onReverseComplete", function(){
            $('body').css({
                overflowY: 'auto',
                height: 'auto'
            });
            $('html, body').off('touchstart touchmove');
            $(placeholder).css({
                zIndex: -1
            });

            placeholder.style.paddingBottom = '0';
            _this.setState({
                pageOpen: false
            });
        });

        $('body').css({
            overflowY: 'hidden',
            height: '100vh'
        });

        $('html, body').off('touchstart touchmove', function(e){
            //prevent native touch activity like scrolling
            e.preventDefault();
        });


        $(placeholder).css({
            zIndex: 999
        });

        this.placeholder = placeholder;

        let list = $('.portfolio-square').not($(a.currentTarget).closest('.portfolio-square')[0]);

        this.setState({
            scrollTop: $(window).scrollTop()
        });


        this.tl
            .fromTo(list, .4, {opacity: 1},{opacity: 0})
            .to({}, .4, {});

        this.tl
            .to(placeholder, .3, { background: 'rgb(246,246,246)'})
            .to(placeholder, .3, { width: '100%', left: 0})
            .to(placeholder, .3, {top: $(window).scrollTop() + 65, height: window.innerHeight + 65})
            .to(placeholder, .3, {background: 'rgb(255,255,255)', onComplete: function () {
                _this.props.actions.selectPortfolio(thing);
                if(window.innerWidth < 500) {
                    placeholder.style.position = 'fixed';
                    placeholder.style.top = 0;
                }
                placeholder.style.paddingBottom = '160px';
                browserHistory.push(_this.props.pathname + '/' + thing);
                _this.setState({
                    pageOpen: true
                });
            }});
    }
    animateClose(){
        this.props.actions.selectPortfolio(null);

        if(this.props.services){
            browserHistory.push('/services/' + this.props.page[0]);
        }else{
            this.props.private? browserHistory.push('/private-portfolio'): browserHistory.push('/portfolio');
        }
        if(this.placeholder && window.innerWidth < 500) {
            this.placeholder.style.position = 'absolute';
            this.placeholder.style.top = $(window).scrollTop();
        }
        this.tl.reverse();
    }
    randomNumber(){
        this.setState({randomNumber: Math.floor(Math.random() * (this.props.items.length))});
    }
    componentWillMount(){
        if(this.props.items){
            this.setState({items: this.props.items});
            this.randomNumber();
        }
    }
    componentDidMount(){
        if(!this.props.selectedService){
            this.setList();
        }
    }
    portfolioTile(index, right){
        let i = this.props.services? this.state.list[index]: index;

        if(this.props.services && this.props.site.loadingPortfolio){
            return <div key={index} name={index} className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                <div className="content">
                    <div className="title">&nbsp;</div>
                    <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                </div>
            </div>
        }else{
            return <ProfileTile
                key={index}
                slug={this.props.items[i].slug}
                image={this.props.items[i].acf.tile_image}
                right={right}
                title={this.props.items[i].title.rendered}
                open={this.animateOpen}
                client={this.props.items[i].client}
                excerpt={this.props.items[i].teaser_text}
            />;
        }

    }
    whiteTile(index, right){
        return <div key={index} name={index} className={right? " portfolio-square col-sm-3 col-xs-6 content-square pull-right": "portfolio-square col-sm-3 col-xs-6 content-square"}>
            <div className="content"></div>
        </div>;
    }
    circleTile(index, right){
        return <div key={index} className={right? "portfolio-square col-sm-3 col-xs-6 circle-block pull-right": "portfolio-square col-sm-3 col-xs-6 circle-block"} data-aos="fade">
            <div className="content">
                <img src={url +  "img/dash-circle.svg"} />
            </div>
        </div>;
    }
    greyTile(index, right){
        if(this.props.services && this.props.site.loadingPortfolio){
            return <div key={index} name={index} className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                <div className="content">
                    <div className="title">&nbsp;</div>
                    <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                </div>
            </div>
        }else{
            let className = right? " portfolio-square col-sm-3 col-xs-6 grey-block content-square pull-right "
                : "portfolio-square col-sm-3 col-xs-6 grey-block content-square";
            return <div key={index} name={index} className={className}>
                <div className="content"></div>
            </div>
        }
    }
    displayPanels(index, i, right){
        if(this.props.site.selectedService){
            if(this.props.site.selectedService.hover_panels[index]) {
                let panel = this.props.site.selectedService.hover_panels[index];
                return (<div key={i} name={i} className={right? "portfolio-square col-sm-6 col-xs-12 large-block pull-right": "portfolio-square col-sm-6 large-block"}>
                    <div className="content">
                        <HoverPanel title={panel.panel_title} text={panel.hover_text} />
                    </div>
                </div>);
            }else{
                return <div key={i} name={i} className={right? "portfolio-square col-sm-6 large-block pull-right": "portfolio-square col-sm-6 large-block"}>
                    <div className="content"></div>
                </div>;
            }
        }
        else{
            return (
                <div key={i} name={i} className={right? "portfolio-square col-sm-6 large-block pull-right": "portfolio-square col-sm-6 large-block"}>
                    <div className="content"></div>
                </div>
            );
        }
    }
    displayPortfolio(index, right){
        let l = [],
            itms = this.props.items,
            lst = this.state.list,
            ls = this.state.list,
            no = 35;


        if(this.props.services){
            if(itms.length < 4) no = 9;
            else if(itms.length < 6) no = 14;
            else if(itms.length < 8) no = 19;
            else if(itms.length < 10) no = 27;
            else if(itms.length < 13) no = 35;


            // let arr = [0,2,5,7,8,10,11,12,13,15,16,18,19,21,22,24,27,29,34];
            // let arr = [100,101,2,103,104,5,106,7,108,109,10,111,112,13,15,116,117,18,119,21,22,24,27,29,34];
            // let arr = [100,101,2,103,104,5,106,7,108,109,10,111,112,13,14,115,116,117,18,119,120,21,22,123,24,125,126,128,29,130,131,132,133,34];

            for(let i = 0; i < no; i++){

                switch (i){
                    case 0:
                    case 3:
                    case 8:
                    case 11:
                    case 12:
                    case 16:
                    case 22:
                    case 2:
                    case 5:
                    case 7:
                    case 10:
                    case 13:
                    case 15:
                    case 18:
                    case 21:
                    case 24:
                    case 27:
                    case 29:
                    case 34:
                        if(itms[lst[i]])l.push(this.portfolioTile(i));
                        else if(window.innerWidth > 500) l.push(this.greyTile(i));
                        break;
                    case 19:
                        if(window.innerWidth > 500) l.push(this.circleTile(i));
                        break;
                    case 6:
                        if(window.innerWidth > 500)l.push(this.displayPanels(0, i, true));
                        break;
                    case 9:
                        if(window.innerWidth > 500)l.push(this.displayPanels(1, i));
                        break;
                    case 14:
                        if(window.innerWidth > 500)l.push(this.displayPanels(2, i, true));
                        break;
                    default:
                        if(window.innerWidth > 500)l.push(this.whiteTile(i));
                        break;
                }
            }
        }else{
            for(let i = 0; i < itms.length; i++){
                // if(i === this.state.randomNumber){
                //     if(i % 2 == 0){
                //         l.push(this.circleTile(i + 525));
                //     }
                // }
                l.push(this.portfolioTile(i));
                if(i === 6 && this.props.site.selectedService ? this.props.site.selectedService.hover_panels[0]? true: false: false){
                    let panel = this.props.site.selectedService.hover_panels[0];
                    l.push(<div key={71284} name={123} className={right? "portfolio-square col-sm-3 col-xs-12 large-block small pull-right": "portfolio-square col-sm-3 small large-block"} data-aos="fade">
                        <div className="content">
                            <HoverPanel title={panel.panel_title} text={panel.hover_text} />
                        </div>
                    </div>)
                }
                if(i === 10 && this.props.site.selectedService ? this.props.site.selectedService.hover_panels[1]? true: false: false){
                    let panel = this.props.site.selectedService.hover_panels[1];
                    l.push(<div key={7128412} name={1233} className={right? "portfolio-square col-sm-3 col-xs-12 large-block small pull-right": "portfolio-square col-sm-3 small large-block"} data-aos="fade">
                        <div className="content">
                            <HoverPanel title={panel.panel_title} text={panel.hover_text} />
                        </div>
                    </div>)
                }
                if(i === 18 && this.props.site.selectedService ? this.props.site.selectedService.hover_panels[2]? true: false: false){
                    let panel = this.props.site.selectedService.hover_panels[2];
                    l.push(<div key={71283412} name={12333} className={right? "portfolio-square col-sm-3 col-xs-12 large-block small pull-right": "portfolio-square col-sm-3 small large-block"} data-aos="fade">
                        <div className="content">
                            <HoverPanel title={panel.panel_title} text={panel.hover_text} />
                        </div>
                    </div>)
                }
            }
        }

        return l;
    }


    detectScroll(e){
        if(e.target.scrollTop > 600 && !this.state.displayScroll){
            this.setState({
                displayScroll: true
            });
        }else if(e.target.scrollTop < 600 && this.state.displayScroll){
            this.setState({
                displayScroll: false
            });
        }
    }
    render() {
        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                onClose: this.animateClose,
                portfolio: this.props.site.selectedPortfolio,
                displayScroll: this.state.displayScroll
            })
        );
        return (
            <div>
            {/*<Display if={this.props.items && this.props.items.length > 0}>*/}
                <div className="portfolio-section" ref="section">
                    <div className="container" ref="container">
                        <div className={this.state.pageOpen? "row disable-touch": "row"}>
                            <Display if={this.props.title}><h3>Portfolio</h3></Display>
                            {this.displayPortfolio()}
                            {/*<Display if={this.props.services && this.props.items.length > 3 && !this.state.expanded}>*/}
                                {/*<div className="down-arrow" onClick={this.expandContent}><i className="fa fa-angle-down"></i></div>*/}
                            {/*</Display>*/}
                            <Display if={this.props.site.loadingPortfolio || this.props.site.searchingPortfolios && !this.props.services}>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                                <div className="portfolio-square col-sm-3 col-xs-6 content-square loading-square">
                                    <div className="content">
                                        <div className="title">&nbsp;</div>
                                        <div className="overlay"><div><p className="project-name">Loading</p></div></div>
                                    </div>
                                </div>
                            </Display>
                        </div>
                    </div>
                </div>
                <div ref="childPage" className="child-page" id="portfolio-item" onScroll={this.detectScroll}>
                    {childrenWithProps}
                </div>
                <Element name="scrollToLoading"/>
            {/*</Display>*/}
                </div>
        );
    }
}


function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioBlock);


/** WEBPACK FOOTER **
 ** ./src/js/components/portfolio/portfolioBlock.js
 **/